var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-chart',{staticStyle:{"height":"400px","postition":"relative"},attrs:{"chart-data":_vm.testData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }